import { render, staticRenderFns } from "./SetOwner.vue?vue&type=template&id=7a776d78&"
import script from "./SetOwner.vue?vue&type=script&lang=js&"
export * from "./SetOwner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports